// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"b042f426","295":"96e7c442","429":"9886e168","761":"dbf97f08","841":"6f3a6829"}[chunkId] + ".css";
};